require('./main.css');

const angular = require('angular');
const amt_admin = require('amt_admin').default;
const app = angular.module('ww2_analytics.conversion_rate', [amt_admin]);
const { provider_states_by_gameplay } = require('amt_admin/utils.js');

app.service('conversion_rate_api', ['jsonrpc', function (jsonrpc) {
  const service = jsonrpc.newService('conversion_rate');
  this.data_by_days = service.createMethod('data_by_days');
  this.data_by_purchases = service.createMethod('data_by_purchases');
}]);

app.config(['$stateProvider',
  function ($stateProvider) {
    provider_states_by_gameplay($stateProvider, {
        adult_idler: [
          'amt.ww2.conversion_rate.by_days',
          'amt.ww2.conversion_rate.by_purchases',
          'amt.ww2.conversion_rate.by_dau',
        ],
      })
      .state('amt.ww2.conversion_rate', {
        url: '/conversion_rate',
        abstract: true,
        template: '<div class="row" ui-view></div>',
        data: {
          priority: 900,
          title: 'Conversion Rate',
          role: 'conversion_rate'
        },
        menu: {
          glyphicon: 'ok-sign',
          childs: [
            {
              state: 'amt.ww2.conversion_rate.by_days',
              glyphicon: 'stats'
            },
            {
              state: 'amt.ww2.conversion_rate.by_purchases',
              glyphicon: 'stats'
            },
            {
              state: 'amt.ww2.conversion_rate.by_first_purchase',
              glyphicon: 'stats'
            },
            {
              state: 'amt.ww2.conversion_rate.by_dau',
              glyphicon: 'stats'
            },
          ]
        }
      })
      .state('amt.ww2.conversion_rate.by_days', require('./by_days').default)
      .state('amt.ww2.conversion_rate.by_purchases', require('./by_purchases').default)
      .state('amt.ww2.conversion_rate.by_first_purchase', require('./by_first_purchase').default)
      .state('amt.ww2.conversion_rate.by_dau', require('./by_dau').default)
  }]);

export default app.name;
